import * as z from "zod";

export const createRithumIntegration = {
  name: "createRithumIntegration" as const,
  input: z.object({
    /** OAuth `code` from the ChannelAdvisor authorization callback. */
    code: z.string(),
  }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().nullish(),
  }),
};
